// @ts-ignore
import styles from './DiscourseHistory.module.scss';
import useDocuments from '../../../Documents/Hooks/useDocuments';
import FlatList from '../../../Base/Components/FlatList';
import { DocumentType } from '../../../../graphql/graphql';
import React, { useEffect, useState } from 'react';
import DiscourseHistoryItem from './DiscourseHistoryItem';
import { useDiscourseContext } from '../../Services/DiscourseContext';

interface Props {
	patientId: string;
	workplaceId: string;
	onShowInCalendar?: () => void;
}

const DiscourseHistory: React.FC<Props> = ({
	patientId,
	workplaceId,
	onShowInCalendar,
}) => {
	const { getDocuments, getNextPage, data, isLoading, page } = useDocuments();
	const { handleEditDiscourseRecord } = useDiscourseContext();

	const [flatData, setFlatData] = useState<any[]>([]);
	const [hasMoreData, setHasMoreData] = useState<boolean>(false);

	useEffect(() => {
		loadDiscourseHistory();
	}, [page]);

	useEffect(() => {
		if (data) {
			const documentsData = data?.documents?.data;
			const totalPages = data?.documents?.meta?.totalPages;
			const page = data?.documents?.meta?.page;

			if (documentsData) {
				if (page && page > 1) {
					setFlatData(prevFlatData => [...prevFlatData, ...documentsData]);
				} else {
					setFlatData(documentsData);
				}
			}

			if (totalPages && page) {
				setHasMoreData(totalPages > page);
			}
		}
	}, [data]);

	const loadDiscourseHistory = () => {
		getDocuments(patientId, workplaceId, [DocumentType.Dekurz]);
	};

	return (
		<div className={styles.list} id='discourseHistoryWrapper'>
			<FlatList
				onRefresh={loadDiscourseHistory}
				onLoadMore={getNextPage}
				data={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={'discourseHistoryWrapper'}
				renderItem={item => (
					<DiscourseHistoryItem
						patientId={patientId}
						item={item}
						handleEdit={handleEditDiscourseRecord}
						onShowInCalendar={onShowInCalendar}
						key={item.id}
					/>
				)}
			/>
		</div>
	);
};

export default DiscourseHistory;
